define.alias("shared/utils/string-formatters/dashed-to-camel", "settings/utils/string-formatters/dashed-to-camel");